import React from 'react';
import { CheckIcon } from 'lucide-react';
import { benefits } from '../data/landing';
export function Benefits() {
  return <section className="w-full bg-cream" aria-labelledby="beneficios-titulo" data-id="element-25" data-mp="9cgvk0aqiekw">
      <div className="mx-auto max-w-content px-6 py-16 md:py-24" data-id="element-26" data-mp="4j4lcv6syabo">
        <h2 id="beneficios-titulo" className="max-w-2xl font-display text-3xl font-semibold leading-tight text-plum sm:text-4xl" data-id="element-27" data-mp="3vr8p5vjb1b5q">
          ¿Qué vas a lograr con este Kit?
        </h2>

        <div className="mt-12 grid grid-cols-1 gap-x-14 gap-y-10 sm:grid-cols-2" data-id="element-28" data-mp="3mpsnqdagwjdn">
          {benefits.map((benefit, index) => <div key={benefit.title} className="flex flex-col border-t border-plum/15 pt-5" data-id="element-29" data-mp="3hrhd40ccm4ud" data-mpi={index}>
              <div className="flex items-center gap-3" data-id="element-30" data-mp="1fzks804ajimx">
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-sage/15 text-sage" data-id="element-31" data-mp="1fz2pckn4i661">
                  <CheckIcon aria-hidden="true" className="h-4 w-4" data-id="element-32" data-mp="1ayez416pxtcv" />
                </span>
                <h3 className="font-display text-xl font-semibold text-plum" data-id="element-33" data-mp="2pwk7ugq7pn3">
                  {benefit.title}
                </h3>
                <span aria-hidden="true" className="ml-auto font-sans text-sm text-plum/30" data-id="element-34" data-mp="3oyo0s8yg3he1">
                  0{index + 1}
                </span>
              </div>
              <p className="mt-3 font-sans text-base leading-relaxed text-ink/75" data-id="element-35" data-mp="lhfl9vr6wtmh">
                {benefit.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}